import { createUseStyles } from "react-jss";
import { colors } from "../../../../constants/colors";
import { breakpoints } from "../../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  statusContainer: {
    borderRadius: "16px",
    padding: "2px 8px",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
    display: "flex",
    alignItems: "center"
  },
  upcoming: {
    extend: "statusContainer",
    backgroundColor: colors.veryLightGrey,
    color: colors.grey,
  },
  checkedin: {
    extend: "statusContainer",
    backgroundColor: colors.green50,
    color: colors.green700,
  },
  canceled: {
    extend: "statusContainer",
    backgroundColor: colors.lightRed,
    color: colors.darkRed,
  },
  startDate: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.lightBlack
  },
  startTime: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.mediumGrey
  },
  checkedout: {
    extend: "statusContainer",
    backgroundColor: colors.blueLight50,
    color: colors.primary500Blue,
  },
  departureStatus: {
    whiteSpace: "nowrap",
    overflow: "visible !important",
    textOverflow: "unset !important",
    "& div": {
      whiteSpace: "nowrap",
      overflow: "visible !important",
      textOverflow: "unset !important",
    }
  },
  nameWrapper: {
    display: "flex",
    minWidth: "100px",
  },
  initialsAvatar: {
    alignSelf: "center",
    width: "40px",
    height: "40px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40px",
    "& span": {
      color: colors.mediumGrey
    }
  },
  badge: {
    color: colors.grayBlue700,
    backgroundColor: colors.grayBlue50,
    padding: "2px 6px 2px 8px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    height: "22px"
  },
  badgeText: {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px"
  },
  detailsWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },
  featuredIconStyle: {
    border: "2px solid" + colors.gray200,
    borderRadius: "10px",
    overflow: "visible !important",
    "& svg": {
      "& rect": {
        fill: colors.white
      },
    },
  },
  name: {
    fontWeight: "500",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: "20px",
    color: colors.choiceGray900,
    "&:focus-visible":{
      border: "1px solid " + colors.primary500Grey
    },
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack
  },
  details: {
    minWidth: "210px",
    marginLeft: "12px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: colors.choiceGray600,
      fontWeight: 400
    }
  },
}));

export default styles;